import axios from 'axios';
import dictionary from '../dictionary';

const apiHost = dictionary.apiHost;


const apiCall = async (endpoint, data) => {
  const ACCESS_TOKEN = localStorage.getItem('ofc');
  const url = apiHost + endpoint;
  const whitesList = [
    'central/watchman/login',
    'central/watchman/signup',
    'central/emailauth/send_verification_email',
    'central/watchman/forgot_password',
    'central/watchman/verify_password_reset',
  ];
  if (!ACCESS_TOKEN && !whitesList.includes(endpoint)) {
    // console.log('Not allowed', endpoint);
    return {status: 'Fail', message: 'Request is not allowed!'};
  }
  //  console.log('API URL Logged in:', url);
  try {
    let response = await axios.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + ACCESS_TOKEN,
        Accept: 'application/json',
        'content-type': 'application/json',
      },
      withCredentials: false, // Ensure no cookies are sent unless required
    });
    return response.data;
  } catch (error) {
    console.log(error);
    let connError = {
      status: error.response.data ? 'Fail' : 'conn',
      message: error.response.data ? error.response.data.message : 'Server connection error occurred!',
      details: {message: 'Contacting server....', content: error.response.data},
    };
    return connError;
  }
};

export default apiCall;
